import { ITradingState } from '../../state/order.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppState } from '../../state/app.state';

export const getTradingState = createFeatureSelector<IAppState, ITradingState>('tradings');

export const selectProductsState = createSelector(
    getTradingState,
    (state: ITradingState) => state.products
);

export const selectCurrentOrderState = createSelector(
    getTradingState,
    (state: ITradingState) => state.orders
);

export const selectRegularInvestmentPlan = createSelector(
    getTradingState,
    (state: ITradingState) => state.investmentPlan
);
